import { render, staticRenderFns } from "./nanjing-en.vue?vue&type=template&id=e0aa2f14&scoped=true"
import script from "./nanjing-en.vue?vue&type=script&lang=js"
export * from "./nanjing-en.vue?vue&type=script&lang=js"
import style0 from "./nanjing-en.vue?vue&type=style&index=0&id=e0aa2f14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0aa2f14",
  null
  
)

export default component.exports